import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

/**
 * Footer Component
 * 
 * @param {string} variant - 'full' for public pages, 'slim' for authenticated pages
 */
const Footer = ({ variant = 'full' }) => {
  // Slim footer for authenticated app pages
  if (variant === 'slim') {
    return (
      <footer className="w-full border-t border-zinc-200 bg-white/50 mt-auto" data-testid="site-footer-slim">
        <div className="mx-auto max-w-7xl px-4 py-4">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-zinc-500">
            <Link 
              to="/support" 
              className="hover:text-zinc-700 transition-colors"
              data-testid="footer-support-link"
            >
              Help & Support
            </Link>
            <span className="hidden sm:inline text-zinc-300">|</span>
            <Link 
              to="/privacy-policy" 
              className="hover:text-zinc-700 transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span className="hidden sm:inline text-zinc-300">|</span>
            <Link 
              to="/terms-and-conditions" 
              className="hover:text-zinc-700 transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    );
  }

  // Full footer for public pages
  return (
    <footer className="w-full bg-zinc-900 text-zinc-400 mt-auto" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Links */}
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
            <Link
              to="/#players"
              className="hover:text-white transition-colors"
              data-testid="footer-players-link"
            >
              Players
            </Link>
            <Link
              to="/trainers"
              className="hover:text-white transition-colors"
              data-testid="footer-trainers-link"
            >
              Trainers
            </Link>
            <Link
              to="/#hosts"
              className="hover:text-white transition-colors"
              data-testid="footer-hosts-link"
            >
              Hosts
            </Link>
            <Link 
              to="/about" 
              className="hover:text-white transition-colors"
              data-testid="footer-about-link"
            >
              About
            </Link>
            <Link 
              to="/community-guidelines" 
              className="hover:text-white transition-colors"
              data-testid="footer-guidelines-link"
            >
              Community Guidelines
            </Link>
            <Link 
              to="/privacy-policy" 
              className="hover:text-white transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-and-conditions" 
              className="hover:text-white transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
            <Link 
              to="/support" 
              className="hover:text-white transition-colors"
              data-testid="footer-support-link"
            >
              Support
            </Link>
            <a 
              href="https://instagram.com/openrunsusa" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors flex items-center gap-1.5"
              data-testid="footer-instagram-link"
            >
              <Instagram className="w-4 h-4" />
              Instagram
            </a>
          </nav>

          {/* Copyright */}
          <p className="text-sm text-zinc-500">
            © Open Runs USA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
